import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { trackButtonClick } from '../utils/analytics';
import '../styles/Navbar.css';

const Navbar: React.FC = () => {
  const [error, setError] = useState('');
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Helper function to check if a path is active
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // Track navigation clicks
  const trackNavClick = (linkName: string) => {
    trackButtonClick(linkName, 'navbar');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => trackNavClick('home_logo')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="logo-icon"
          >
            <path d="M18 8h1a4 4 0 1 1 0 8h-1"></path>
            <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
            <line x1="6" y1="1" x2="6" y2="4"></line>
            <line x1="10" y1="1" x2="10" y2="4"></line>
            <line x1="14" y1="1" x2="14" y2="4"></line>
          </svg>
          <span className="logo-text">AI Meal Planner</span>
        </Link>
        <ul className="nav-menu">
          {currentUser ? (
            <>
              <li className="nav-item">
                <Link
                  to="/meal-planner"
                  className={`nav-links ${isActive('/') || isActive('/meal-planner') ? 'active' : ''}`}
                  onClick={() => trackNavClick('create_meal_plan')}
                >
                  Create Meal Plan
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/recipes-by-ingredients"
                  className={`nav-links ${isActive('/recipes-by-ingredients') ? 'active' : ''}`}
                  onClick={() => trackNavClick('recipes_by_ingredients')}
                >
                  Find Meals by Ingredients
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/saved-meals"
                  className={`nav-links ${isActive('/saved-meals') ? 'active' : ''}`}
                  onClick={() => trackNavClick('saved_meals')}
                >
                  Saved Meals
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/account"
                  className={`nav-links account-icon ${isActive('/account') ? 'active' : ''}`}
                  onClick={() => trackNavClick('account')}
                  title="Account"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </Link>
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link
                  to="/recipes-by-ingredients"
                  className={`nav-links ${isActive('/recipes-by-ingredients') || isActive('/') ? 'active' : ''}`}
                  onClick={() => trackNavClick('recipes_by_ingredients')}
                >
                  Find Meals by Ingredients
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/login"
                  className={`nav-links ${isActive('/login') ? 'active' : ''}`}
                  onClick={() => trackNavClick('login')}
                >
                  Log In
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/signup"
                  className={`nav-links ${isActive('/signup') ? 'active' : ''}`}
                  onClick={() => trackNavClick('signup')}
                >
                  Sign Up
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 